module.exports = __webpack_public_path__ + "static/media/dubai-internet-city.fa301be5.svg";